import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import APP_CONSTANTS from '../../config/constants';
import Axios from 'axios';
import $ from 'jquery'
import ReadAxios from '../axiosComponent/read';
const MySku = ({
    field: { name, value },
    form: { touched, errors, setFieldValue },
    ...props
}) => {
    const errorText = touched[name] && errors[name];
    const [contents, setcontents] = useState([])
    const [loading, setloading] = useState(false)
    // const [skuId, setSkuId] = useState('')
    useEffect(() => {
        // setSkuId(props.skuId)
        // console.log(props, skuId)
        ReadAxios({ url: `skuMaster/` })
            .then((result) => {
                setcontents(result)
                setloading(false)
            })
    }, [])

    let options = []
    if (contents.length > 0) {
        contents.map((object, index) => {
            let temp = {}
            temp.key = object.skuMasterId
            temp.text = `${object.skuName} (${object.skuCode})`
            temp.value = object.skuCode
            temp.extra = object
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
    }
    return (
        <Dropdown
            selection
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            {...props}
        />

    )
}

export default MySku